import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { useAtomValue } from 'jotai';

import { UserRole } from '../interfaces/role';

export function useRole() {
  const teacherProfile = useAtomValue(teacherProfileAtom);

  const role = teacherProfile?.roleDto.role as UserRole;

  const isTeacher = [UserRole.Teacher].includes(role);
  const isMonitor = [UserRole.Monitor].includes(role);
  const isAdmin = [
    UserRole.AcadAdmin,
    UserRole.SysAdmin,
    UserRole.TeacherAdmin,
  ].includes(role);

  return {
    role,
    isTeacher,
    isMonitor,
    isAdmin,
  };
}
